import { isActiveMerchantMemberWithoutRole, type MerchantRbacRoleState } from './merchantRbac';

type CompanyInformationIdentity = MerchantRbacRoleState & {
  apiIdentity?: boolean;
  primaryAdmin?: boolean;
};

const companyInformationPaths = new Set([
  '/company-management',
  '/company-management/info',
  '/company-management/base',
  '/company-management/add',
  '/company-management/nda',
  '/company-management/due-diligence-form',
  '/company-management/aml-ctf-scp-questionnaire',
  '/company-management/contract-management',
]);

/** Registration and primary identities can manage company information without a role-route grant. */
export const canAccessMerchantCompanyInformation = (state?: CompanyInformationIdentity): boolean =>
  state?.rbacScope === true &&
  state.status === 'ACTIVE' &&
  (state.apiIdentity === true || state.primaryAdmin === true);

export const isMerchantCompanyInformationRoute = (path?: string): boolean =>
  !!path && companyInformationPaths.has(path);

/** The registration identity needs the application flow, not the role-assignment guidance. */
export const shouldShowUnassignedRoleGuidance = (state?: CompanyInformationIdentity): boolean =>
  isActiveMerchantMemberWithoutRole(state) && !canAccessMerchantCompanyInformation(state);
